import { Entry } from 'contentful'
import rfdc from 'rfdc'
const cloneDeep = rfdc({ proto: false })

import { pickDataAttrs } from '../../utils/dataAttributes'

/*
 * Generics
 * ---
 * C: Contentful props
 * R: React props
 * K: key of React Props
 */

export type ContentfulToPropsMap<C, R, K extends keyof R> = (prop: { fields: C; sys: any; metadata: any }) => R[K]

export type MapObject<C, R> = Partial<{
  [Prop in keyof R]: ContentfulToPropsMap<C, R, Prop> | keyof C
}>

export function mapProps<C, R>(props: Entry<any>, contentfulToPropsMap: MapObject<C, R>): C {
  const entryFields = props.fields as Record<string, unknown>
  const mappedProps: any = entryFields
  const dataAttrs = pickDataAttrs(props as unknown as Record<string, unknown>)
  if (!contentfulToPropsMap) {
    return { ...mappedProps, ...dataAttrs }
  }

  Object.entries(contentfulToPropsMap).forEach(([key, value]) => {
    try {
      if (typeof value === 'function') {
        mappedProps[key] = value(props as { fields: C; sys: any; metadata: any })
      } else {
        mappedProps[key] = entryFields[value as string]
      }
    } catch (e) {
      console.error(e)
    }
  })

  return { ...mappedProps, ...dataAttrs }
}

export function withContentful<C, R = Record<string, unknown>>(Component, contentfulToPropsMap?: MapObject<C, R>) {
  const RenderedComponent: React.FC<Entry<any>> = (props) => {
    const clonedProps = cloneDeep(props) as typeof props
    const mappedProps = mapProps<C, R>(clonedProps, contentfulToPropsMap)
    delete clonedProps.fields
    delete clonedProps.metadata

    return <Component {...mappedProps} {...clonedProps} sys={props.sys} />
  }

  return RenderedComponent
}
